module.exports = __webpack_public_path__ + "images/emoji/shoe.e0adac2047ad9248d5cd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/shoe.png
// module id = z1Gb
// module chunks = 14